"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchHandler = exports.instance = void 0;
var axios_1 = __importDefault(require("axios"));
var config_1 = __importDefault(require("config"));
var ApiStore_1 = __importDefault(require("stores/ApiStore"));
var UserStore_1 = __importDefault(require("stores/UserStore"));
var apiRoutes = config_1.default.apiRoutes;
exports.instance = axios_1.default.create({
    withCredentials: true,
    baseURL: config_1.default.apiBase,
    timeout: 20000,
    params: {}
});
function pushToBusy(url) {
    var busyRoutes = ApiStore_1.default.data.busyRoutes;
    var inBusy = ApiStore_1.default.data.busyRoutes.includes(url);
    if (!inBusy)
        busyRoutes.push(url);
    return busyRoutes;
}
/** For testing loading icons etc **/
var stall = function () { return new Promise(function (resolve) {
    setTimeout(function () { resolve(true); }, 5000);
}); };
exports.instance.interceptors.request.use(function (axiosConfig) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        ApiStore_1.default.editData({
            busy: true,
            busyRoutes: pushToBusy(axiosConfig.url.replace(/\/\d+/, '')),
            busyMethod: axiosConfig.method,
            error: null
        });
        // Just enter the method and route to stall to test loading effects etc
        // if (axiosConfig.method === 'post' && axiosConfig.url === apiRoutes.PROJECTS) {
        //   await stall();
        // }
        return [2 /*return*/, axiosConfig];
    });
}); }, function (error) {
    return Promise.reject(error);
});
exports.instance.interceptors.response.use(function (response) {
    ApiStore_1.default.editData({
        busy: false,
        busyRoutes: ApiStore_1.default.data.busyRoutes.filter(function (url) {
            return response.config.url.replace(/\/\d+/, '') !== url;
        }),
        busyMethod: null
    });
    return response;
}, function (error) {
    if (error.response) {
        if (error.response.status === 401) {
            if (error.config.url === apiRoutes.LOGIN)
                return;
            setTimeout(function () {
                localStorage.removeItem(config_1.default.storageKeys.USER);
                UserStore_1.default.unsetData();
            }, 500);
        }
    }
    return Promise.reject(error);
});
function catchHandler(error) {
    ApiStore_1.default.editData(__assign(__assign({}, ApiStore_1.default.data), { busy: false, busyRoutes: [], busyMethod: null, error: error.response && error.response.data.error || config_1.default.genericError }));
}
exports.catchHandler = catchHandler;
exports.default = {
    login: function (data) { return exports.instance.post(apiRoutes.LOGIN, data); },
    logout: function () { return exports.instance.get(apiRoutes.LOGOUT); },
    getSelf: function () { return exports.instance.get(apiRoutes.SELF); },
    editSelf: function (user) { return exports.instance.patch(apiRoutes.SELF, user); },
    changePassword: function (passwordData) { return exports.instance.patch(apiRoutes.SELF + "/change-password", passwordData); },
    getAllUsers: function () { return exports.instance.get(apiRoutes.ALL_USERS); },
    addUser: function (user) { return exports.instance.post(apiRoutes.ALL_USERS, user); },
    editUser: function (user) { return exports.instance.patch(apiRoutes.ALL_USERS + ("/" + user.id), user); },
    deleteUser: function (user) { return exports.instance.delete(apiRoutes.ALL_USERS + ("/" + user.id)); },
    getClients: function () { return exports.instance.get(apiRoutes.CLIENTS); },
    addClient: function (client) { return exports.instance.post(apiRoutes.CLIENTS, client); },
    editClient: function (id, client) { return exports.instance.post(apiRoutes.CLIENTS + ("/" + id), client); },
    deleteClient: function (client) { return exports.instance.delete(apiRoutes.CLIENTS + ("/" + client.id)); },
    getProjects: function () { return exports.instance.get(apiRoutes.PROJECTS); },
    addProject: function (project) { return exports.instance.post(apiRoutes.PROJECTS, project); },
    editProject: function (project) { return exports.instance.patch(apiRoutes.PROJECTS + ("/" + project.id), project); },
    deleteProject: function (project) { return exports.instance.delete(apiRoutes.PROJECTS + ("/" + project.id)); },
    addTask: function (task) { return exports.instance.post(apiRoutes.TASKS); },
    editTask: function (task) { return exports.instance.patch(apiRoutes.TASKS); }
};
